import 'swiped-events';

document.addEventListener("DOMContentLoaded", () => {
    let slider = document.querySelector('.homepage-slider');
    if (slider) {
        let objectSlider = new HomepageSlider(slider);
        objectSlider.init();
    }
});

class HomepageSlider {
    constructor(slider) {
        this.slider = slider;
        this.slides = slider.querySelectorAll('.homepage-slider__slide');
        this.wrap = slider.querySelector('.homepage-slider__wrap');
        this.countSlides = this.slides.length;
        this.slideIndex = 1;
        this.interval = null;
    }

    init() {

        let that = this;

        this.slider.querySelector('.homepage-slider-right').addEventListener('click', () => {
            that.slideRight();
        });
        this.slider.querySelector('.homepage-slider-left').addEventListener('click', () => {
            that.slideLeft();
        });
        this.slider.addEventListener('swiped-right', () => {
            that.slideLeft();
        });
        this.slider.addEventListener('swiped-left', () => {
            that.slideRight();
        });

        this.incrementPagination();
        if (this.countSlides > 1) {
            let firstCloned = this.slides[0].cloneNode(true);
            let lastCloned = this.slides[this.countSlides -1].cloneNode(true);
            this.wrap.appendChild(firstCloned);
            this.wrap.prepend(lastCloned);
            this.wrap.classList.add('no-transition')
            this.wrap.style.left = (this.slideIndex * -100) + '%';

            this.setInterval();
        }
    }
    restartInterval() {
        clearInterval(this.interval);
        this.setInterval();
    }

    setInterval() {
        let that = this;
        this.interval = setInterval(() => {
            this.slideIndex++;
            this.wrap.classList.remove('no-transition');
            that.slide();
        }, 5000);

    }

    slide() {
        this.wrap.style.left = (this.slideIndex * -100) + '%';
        let that = this;
        setTimeout(function () {
            if (that.slideIndex > that.countSlides) {
                that.wrap.classList.add('no-transition');
                that.slideIndex = 1;
                that.slide();
            } else if(that.slideIndex === 0) {
                that.wrap.classList.add('no-transition');
                that.slideIndex = that.countSlides;
                that.slide();
            } else {
                that.incrementPagination();
            }
        }, 400);

    }

    slideRight() {
        this.restartInterval();
        this.slideIndex++;
        this.wrap.classList.remove('no-transition');
        this.slide();
    }

    slideLeft() {
        this.restartInterval();
        this.slideIndex--;
        this.wrap.classList.remove('no-transition');
        this.slide();
    }

    incrementPagination() {
        let pagination = this.slider.querySelector('.homepage-slider__pagination');
        pagination.querySelector('.homepage-slider__index').innerText = this.slideIndex;

        pagination.querySelector('.homepage-slider__pagination-slide div').style.width = (100 / this.countSlides * (this.slideIndex)) + "%";
    }
}
